import { render, staticRenderFns } from "./StatisticsRadio.vue?vue&type=template&id=d679edf8&scoped=true&"
import script from "./StatisticsRadio.vue?vue&type=script&lang=js&"
export * from "./StatisticsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d679edf8",
  null
  
)

export default component.exports